var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.className == 'sub-tab-wrap' ? _c('div', {
    class: _vm.className
  }, [_vm._l(_vm.gnbs, function (item) {
    return [item.title == _vm.sh ? _c('ul', {
      key: item.title,
      staticClass: "tab tab--block"
    }, _vm._l(item.children, function (child) {
      return _c('li', {
        key: child.title,
        staticClass: "tab__li",
        class: {
          active: _vm.tabActive == child.title
        }
      }, [_c('a', {
        staticClass: "tab__btn",
        attrs: {
          "href": child.path
        }
      }, [_c('span', {
        staticClass: "word-keep-all"
      }, [(child === null || child === void 0 ? void 0 : child.title) == '연구개발 및 교육사업' ? [_vm._v(" 연구개발 "), _c('br'), _vm._v(" 및 교육사업 ")] : [_vm._v(" " + _vm._s(child.title) + " ")]], 2)])]);
    }), 0) : _vm._e()];
  })], 2) : _vm.className == 'gnb' ? _c('ul', {
    class: _vm.className
  }, [_vm._l(_vm.gnbs, function (item) {
    return [item.hide !== true ? [!item.group1 && !item.group2 && !item.group3 && !item.group4 ? _c('li', {
      key: item.title,
      class: _vm.className + '__li'
    }, [_c('router-link', {
      class: _vm.className + '__link',
      attrs: {
        "to": item.path
      }
    }, [_c('h2', [_vm._v(_vm._s(item.title))])])], 1) : [_c('v-hover', {
      key: item.title,
      attrs: {
        "transition": "fade-transition"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref) {
          var hover = _ref.hover;
          return [_c('li', {
            staticClass: "d-none d-xl-block",
            class: _vm.className + '__li'
          }, [_vm.isMobile ? _c('div', {
            class: _vm.className + '__link gnb__link--toggle'
          }, [_c('h2', [_vm._v(_vm._s(item.title))])]) : _c('router-link', {
            class: _vm.className + '__link gnb__link--toggle',
            attrs: {
              "to": item.path
            }
          }, [_c('h2', [_vm._v(" " + _vm._s(item.title) + " ")])]), hover ? [_c('v-fade-transition', [_c('v-card', {
            staticClass: "new-sub",
            attrs: {
              "tile": "",
              "flat": "",
              "width": "100%"
            }
          }, [_c('v-row', {
            staticClass: "row--sm"
          }, [_c('v-col', {
            attrs: {
              "cols": "3"
            }
          }, [_c('router-link', {
            staticClass: "font-weight-bold font-size-20",
            attrs: {
              "to": item.path
            }
          }, [_vm._v(" " + _vm._s(item.title) + " ")])], 1), _c('v-col', [_c('v-row', [item.group1 ? _c('v-col', {
            attrs: {
              "cols": "3"
            }
          }, [_c('v-row', {
            staticClass: "row--sm"
          }, _vm._l(item.group1, function (child) {
            return _c('v-col', {
              key: child.title,
              attrs: {
                "cols": "12"
              }
            }, [_c('router-link', {
              staticClass: "font-weight-medium",
              attrs: {
                "to": child.path
              }
            }, [_vm._v(" " + _vm._s(child.title) + " ")]), child.children ? _c('v-row', {
              staticClass: "row--xxs pt-16 grey-6--text"
            }, _vm._l(child.children, function (grandChild) {
              return _c('v-col', {
                key: grandChild.title,
                attrs: {
                  "cols": "12"
                }
              }, [_c('router-link', {
                attrs: {
                  "to": grandChild.path
                }
              }, [_vm._v(" " + _vm._s(grandChild.title) + " ")])], 1);
            }), 1) : _vm._e()], 1);
          }), 1)], 1) : _vm._e(), item.group2 ? _c('v-col', {
            attrs: {
              "cols": "3"
            }
          }, [_c('v-row', {
            staticClass: "row--sm"
          }, _vm._l(item.group2, function (child) {
            return _c('v-col', {
              key: child.title,
              attrs: {
                "cols": "12"
              }
            }, [_c('router-link', {
              staticClass: "font-weight-medium",
              attrs: {
                "to": child.path
              }
            }, [_vm._v(" " + _vm._s(child.title) + " ")]), child.children ? _c('v-row', {
              staticClass: "row--xxs pt-16 grey-6--text"
            }, _vm._l(child.children, function (grandChild) {
              return _c('v-col', {
                key: grandChild.title,
                attrs: {
                  "cols": "12"
                }
              }, [_c('router-link', {
                attrs: {
                  "to": grandChild.path
                }
              }, [_vm._v(" " + _vm._s(grandChild.title) + " ")])], 1);
            }), 1) : _vm._e()], 1);
          }), 1)], 1) : _vm._e(), item.group3 ? _c('v-col', {
            attrs: {
              "cols": "3"
            }
          }, [_c('v-row', {
            staticClass: "row--sm"
          }, _vm._l(item.group3, function (child) {
            return _c('v-col', {
              key: child.title,
              attrs: {
                "cols": "12"
              }
            }, [_c('router-link', {
              staticClass: "font-weight-medium",
              attrs: {
                "to": child.path
              }
            }, [_vm._v(" " + _vm._s(child.title) + " ")]), child.children ? _c('v-row', {
              staticClass: "row--xxs pt-16 grey-6--text"
            }, _vm._l(child.children, function (grandChild) {
              return _c('v-col', {
                key: grandChild.title,
                attrs: {
                  "cols": "12"
                }
              }, [_c('router-link', {
                attrs: {
                  "to": grandChild.path
                }
              }, [_vm._v(" " + _vm._s(grandChild.title) + " ")])], 1);
            }), 1) : _vm._e()], 1);
          }), 1)], 1) : _vm._e(), item.group4 ? _c('v-col', {
            attrs: {
              "cols": "3"
            }
          }, [_c('v-row', {
            staticClass: "row--sm"
          }, _vm._l(item.group4, function (child) {
            return _c('v-col', {
              key: child.title,
              attrs: {
                "cols": "12"
              }
            }, [_c('router-link', {
              staticClass: "font-weight-medium",
              attrs: {
                "to": child.path
              }
            }, [_vm._v(" " + _vm._s(child.title) + " ")]), child.children ? _c('v-row', {
              staticClass: "row--xxs pt-16 grey-6--text"
            }, _vm._l(child.children, function (grandChild) {
              return _c('v-col', {
                key: grandChild.title,
                attrs: {
                  "cols": "12"
                }
              }, [_c('router-link', {
                attrs: {
                  "to": grandChild.path
                }
              }, [_vm._v(" " + _vm._s(grandChild.title) + " ")])], 1);
            }), 1) : _vm._e()], 1);
          }), 1)], 1) : _vm._e()], 1)], 1)], 1), _c('div', {
            staticClass: "new-sub__bg"
          })], 1)], 1)] : _vm._e()], 2)];
        }
      }], null, true)
    })]] : _vm._e()];
  })], 2) : _c('v-list', {
    staticClass: "d-xl-none mobile-list"
  }, [_vm._l(_vm.gnbs, function (item, index) {
    return [item.hide !== true ? [!item.group1 && !item.group2 && !item.group3 && !item.group4 ? _c('v-list-item', {
      key: index
    }, [_vm._v(" " + _vm._s(item.title) + " ")]) : _c('v-list-group', {
      key: index,
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function () {
          return [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.title) + " ")])];
        },
        proxy: true
      }], null, true)
    }, [item.group1 ? [_vm._l(item.group1, function (child, index) {
      return [child.children ? [_c('v-list-group', {
        key: index,
        attrs: {
          "sub-group": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function () {
            return [_c('v-list-item-title', [_vm._v(" " + _vm._s(child.title) + " ")])];
          },
          proxy: true
        }], null, true)
      }, _vm._l(child.children, function (grandChild, index) {
        return _c('v-list-item', {
          key: index,
          attrs: {
            "to": grandChild.path
          }
        }, [_vm._v(" " + _vm._s(grandChild.title) + " ")]);
      }), 1)] : [_c('v-list-item', {
        key: index,
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")])]];
    })] : _vm._e(), item.group2 ? [_vm._l(item.group2, function (child, index) {
      return [child.children ? [_c('v-list-group', {
        key: index,
        attrs: {
          "sub-group": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function () {
            return [_c('v-list-item-title', [_vm._v(" " + _vm._s(child.title) + " ")])];
          },
          proxy: true
        }], null, true)
      }, _vm._l(child.children, function (grandChild, index) {
        return _c('v-list-item', {
          key: index,
          attrs: {
            "to": grandChild.path
          }
        }, [_vm._v(" " + _vm._s(grandChild.title) + " ")]);
      }), 1)] : [_c('v-list-item', {
        key: index,
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")])]];
    })] : _vm._e(), item.group3 ? [_vm._l(item.group3, function (child, index) {
      return [child.children ? [_c('v-list-group', {
        key: index,
        attrs: {
          "sub-group": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function () {
            return [_c('v-list-item-title', [_vm._v(" " + _vm._s(child.title) + " ")])];
          },
          proxy: true
        }], null, true)
      }, _vm._l(child.children, function (grandChild, index) {
        return _c('v-list-item', {
          key: index,
          attrs: {
            "to": grandChild.path
          }
        }, [_vm._v(" " + _vm._s(grandChild.title) + " ")]);
      }), 1)] : [_c('v-list-item', {
        key: index,
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")])]];
    })] : _vm._e(), item.group4 ? [_vm._l(item.group4, function (child, index) {
      return [child.children ? [_c('v-list-group', {
        key: index,
        attrs: {
          "sub-group": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function () {
            return [_c('v-list-item-title', [_vm._v(" " + _vm._s(child.title) + " ")])];
          },
          proxy: true
        }], null, true)
      }, _vm._l(child.children, function (grandChild, index) {
        return _c('v-list-item', {
          key: index,
          attrs: {
            "to": grandChild.path
          }
        }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(grandChild.title) + " ")])], 1);
      }), 1)] : [_c('v-list-item', {
        key: index,
        attrs: {
          "to": child.path
        }
      }, [_vm._v(" " + _vm._s(child.title) + " ")])]];
    })] : _vm._e()], 2)] : _vm._e()];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }